
import Vue from 'vue'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import ProspectFastForm from '@/components/forms/ProspectFastForm.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')

@Component({
  components: {
    PageLayout,
    PageMenuLayout,
    BaseFormContainer,
    ProspectFastForm
  }
})
export default class ProspectCreateExternal extends Vue {
  @prospectModule.Action('createProspectMcoAction') createProspectMco: any

  onSubmit(data: any) {
    this.createProspectMco(data).then(async (data: any) => {
      const ref = this.$refs.form as any
      if (ref) ref.resetForm()
      Vue.notify({
        group: 'user',
        type: 'success',
        title: 'Confirmation',
        text: 'Les données ont bien été enregistrés, Merci'
      })
      this.$nextTick(() => VueScrollTo.scrollTo('#app'))
    })
  }

  onCancel() {
    const ref = this.$refs.form as any
    if (ref) ref.resetForm()
  }
}
